import { textColumn } from '@/shared/grids/columns/textColumn';
import { ClientType, IndividualRelationshipType, OrganisationRelationshipType } from '@/shared/types/enum';
import { GridColumnSettings } from '@/shared/types/grid';
import { enumOptions } from '@/shared/utils/enum';
import { formatEnum } from '@/shared/utils/format';

import { IndividualView, OrganisationView } from '@prisma/client';

export const relationshipTypeColumn = <T extends OrganisationView | IndividualView>(options: {
  uid?: string;
  field: keyof T & string;
  clientType: ClientType;
  chooserName?: string;
}): GridColumnSettings<T> => {
  const { uid, field, clientType, chooserName } = options;

  return textColumn({
    uid,
    field,
    header: 'Relationship',
    template: (data) =>
      formatEnum({ ...OrganisationRelationshipType, ...IndividualRelationshipType }, data.relationshipType),
    extra: {
      displayField: 'relationshipType',
      filter: {
        options: enumOptions(
          clientType === ClientType.Organisation ? OrganisationRelationshipType : IndividualRelationshipType,
        ),
      },
    },
    visible: false,
    chooserName,
  });
};
